import { handoverModel } from '../../api';
import {
  setError,
  setLoading,
  setInvalidSearch,
  setShowEmptyState,
} from '../orders/actions';
import { sendEventToJumbo } from '../../helpers/analytics';

export const SET_HANDOVER_DATA = 'SET_HANDOVER_DATA';
export const setHandoverData = (data) => ({
  type: SET_HANDOVER_DATA,
  data,
});

export const getHandoverData = (params) => (dispatch) => {
  return handoverModel
    .getHandoverData(params)
    .then((response) => {
      if (!response || (response && response.isError === true)) {
        dispatch(setError(true));
        dispatch(setLoading(false));
        return;
      }
      sendEventToJumbo('get_handover_data_success');
      dispatch(setHandoverData(response));
      setShowEmptyState(false);
      setLoading(true);
    })
    .catch((err) => {
      sendEventToJumbo('get_handover_data_failed', { err });
      console.log('handover error', err);
      dispatch(setError(true));
      dispatch(setLoading(false));
    });
};
